export default __webpack_public_path__ + "static/media/Scto-Grotesk-A-Regular.6dc53a51.ttf";